/**
 * Package Evidence View helpers — bureau comparison ordering and derogatory styling.
 */

const BUREAU_COMPARISON_FIELD_ORDER = [
  'account_type_detail',
  'account_status',
  'payment_status',
  'responsibility',
  'date_opened',
  'last_reported',
  'date_last_active',
  'date_of_last_payment',
  'comments',
];

const FIELD_LABEL_OVERRIDES = {
  account_type_detail: 'Account Type Detail',
  account_status: 'Account Status',
  payment_status: 'Payment Status',
  date_of_last_payment: 'Date Of Last Payment',
};

export function formatBureauComparisonFieldLabel(fieldKey) {
  if (FIELD_LABEL_OVERRIDES[fieldKey]) {
    return FIELD_LABEL_OVERRIDES[fieldKey];
  }
  return fieldKey
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function isDerogatoryEvidenceValue(value) {
  if (value == null || value === '' || value === '-') return false;
  const s = String(value).toLowerCase();
  if (s.includes('collection or charge off')) return true;
  if (s.includes('collection/charge-off')) return true;
  if (s.includes('charge off') || s.includes('charge-off') || s.includes('chargeoff')) return true;
  if (/\b120\b/.test(s) && s.includes('late')) return true;
  if (/\b150\b/.test(s) && s.includes('late')) return true;
  if (s.includes('collection') && !s.includes('pays as agreed')) return true;
  return false;
}

export function bureauComparisonRowHasValue(values) {
  return Object.values(values || {}).some((v) => v != null && v !== '');
}

export function buildOrderedBureauComparisonEntries(bureauComparison) {
  if (!bureauComparison || typeof bureauComparison !== 'object') return [];

  const entries = Object.entries(bureauComparison).filter(([, values]) =>
    bureauComparisonRowHasValue(values)
  );
  const orderIndex = (key) => {
    const idx = BUREAU_COMPARISON_FIELD_ORDER.indexOf(key);
    return idx === -1 ? BUREAU_COMPARISON_FIELD_ORDER.length + 1 : idx;
  };

  return entries.sort(([a], [b]) => {
    const diff = orderIndex(a) - orderIndex(b);
    return diff !== 0 ? diff : a.localeCompare(b);
  });
}

export function resolveEvidencePaymentStatus(evidence) {
  if (!evidence) return '';
  if (evidence.payment_status) return evidence.payment_status;
  const row = evidence.bureau_comparison?.payment_status;
  if (row && typeof row === 'object') {
    const values = Object.values(row).filter((v) => v != null && v !== '');
    if (values.length) return values[0];
  }
  return '';
}

export function bureauComparisonTableVisible(bureauComparison) {
  return buildOrderedBureauComparisonEntries(bureauComparison).length > 0;
}
